<template>
  <div style="padding: 16px">
    <div class="d-flex d-aligncnter">
      <img
        class="img-24"
        src="@/assets/img/academic/tips.svg"
        style="width: 0.5rem; height: 0.5rem"
      />
      <div class="left-title ml-4">各学院体育教育挂科率分析</div>
    </div>
    <div class="grey mt-16" style="font-size: 0.4rem">挂科总数</div>
    <div class="grey mt-8 d-aligncnter" style="font-size: 0.6rem">
      {{ failRateData.sumCount }}
      <div
        class="d-flex d-aligncnter mt-8"
        style="font-size: 0.4rem; margin-left: 8px"
      >
        <span class="green">较上学期增加</span>
        <span class="yellow">{{ failRateData.changeRate * 100 }}%</span>
        <img class="img-16" src="@/assets/img/academic/upy.svg" />
      </div>
    </div>

    <div class="mt-16"></div>
    <div
      class="d-flex"
      v-for="(item, index) in failRateData.resList"
      :key="'fail_' + index"
      style="margin-bottom: 7px"
    >
      <div class="each-line">
        <div
          class="hascolor"
          :style="{ width: item.failRate * 100 + '%' }"
        ></div>
        <div class="branch-name">{{ item.collegeName }}</div>
      </div>
      <div class="nums">{{ item.failNum }}</div>
      <div class="percent">{{ item.failRate * 100 }}%</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['failRateData'],
  data() {
    return {}
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.each-line {
  font-size: 0.35rem;
  position: relative;
  width: calc(100% - 2.4rem);
  .hascolor {
    // width: calc(100% - 112px);
    // height: 18px;
    height: 0.6rem;
    background: linear-gradient(110deg, #ff8383 10.99%, #f52828 89.01%);
    opacity: 0.5;
    border-radius: 2px;
  }
  .branch-name {
    position: absolute;

    line-height: 0.6rem;
    left: 8px;
    top: 0px;
  }
}
.nums {
  width: 1.2rem;
  margin-left: 8px;
  font-size: 0.4rem;
  text-align: center;
}
.percent {
  width: 1.2rem;
  margin-left: 8px;
  font-size: 0.4rem;
  text-align: center;
}
</style>
